module.exports = __webpack_public_path__ + "img/4@2x.91349675.png";